module.exports = __webpack_public_path__ + "img/slider-handle-3.69d447952bfda9a67e2b5d12a809e516.svg";